//账户设置表单
export default async vm => {
  const dic = JSON.parse(localStorage.dic);
  const data = dic['USER_CARD_TYPE'];
  const keys = Object.keys(data);
  console.log(keys);
  const arr = keys.map(code => {
    return {
      value: code,
      label: data[code]
    };
  });
  let res = await vm.$http({
    type: 'POST',
    url: '/buz/userBase/getByOrgIds',
    data: {
      type: 2
    }
  });
  let userList = res.data.map(item => {
    return {
      label: item.name,
      value: item.id
    };
  });
  return [
    {
      title: {
        label: '账号信息'
      },
      data: [
        {
          name: '登录账号',
          value: '',
          key: 'account',
          type: 1,
          readonly: true
        },
        {
          name: '所属机构',
          value: '',
          type: 1,
          key: 'organizationName',
          readonly: true
        },
        {
          name: '状态',
          value: '',
          type: 1,
          key: 'status',
          readonly: true,
          render(h, item) {
            if (item.value == 0) {
              return <span>无效</span>;
            } else {
              return <span>有效</span>;
            }
          }
        },
        {
          name: '角色',
          value: '',
          type: 1,
          key: 'roles',
          readonly: true,
          render(h, item) {
            console.log(item, 'itemitem');
            // var a = [item.value[0]]
            var name = '';
            item.value.forEach(el => {
              name += el + ' ';
            });
            return <span>{name}</span>;
            // return item.value.map(item => <span>{item}</span>)
          }
        }
      ]
    },
    {
      title: {
        label: '基本信息'
      },
      data: [
        {
          name: '用户姓名',
          key: 'userName',
          value: '',
          type: 1,
          rules: [
            {
              required: true,
              message: '请输入用户姓名'
            }
          ]
        },
        {
          name: '手机号',
          key: 'mobile',
          value: '',
          type: 1,
          rules: [
            {
              required: true,
              pattern: /^[1][0-9][0-9]{9}$/,
              message: '请输入正确格式的手机号',
              transform(value) {
                return Number(value);
              }
            }
          ]
        },
        // {
        //   name: '关联内勤',
        //   key: 'indoorStaffId',
        //   value: '',
        //   type: 2,
        //   arr: userList
        // }
        // {
        //   name: '证件类型',
        //   key: 'idType',
        //   value: '',
        //   type: 2,
        //   clearable: true,
        //   arr,
        //   fn(value, item) {
        //     console.log(value, item);
        //     console.log(vm.formDateAddServer);
        //     if (value == '01') {
        //       //身份证类型校验证件号
        //       vm.formDateAddServer[1].data[3].hidden = true;
        //       vm.formDateAddServer[1].data[4].hidden = false;
        //     } else {
        //       vm.formDateAddServer[1].data[3].hidden = false;
        //       vm.formDateAddServer[1].data[4].hidden = true;
        //     }
        //   },
        //   rules: [
        //     {
        //       required: true,
        //       message: '选择证证件类型'
        //     }
        //   ]
        // },
        // {
        //   name: '证件号',
        //   key: 'idNo',
        //   value: '',
        //   type: 1,
        //   hidden: false,
        //   rules: [
        //     {
        //       required: true,
        //       trigger: 'change',
        //       validator(rule, value, callback) {
        //         if(!value){
        //           callback(new Error('请输入证件号'));
        //         }else if (value.length < 6) {
        //           callback(new Error('证件号至少6位'));
        //         }else {
        //           callback();
        //         }
        //       }
        //     }
        //   ]
        // },
        // {
        //   name: '证件号',
        //   key: 'idNo',
        //   value: '',
        //   type: 1,
        //   hidden: true,
        //   rules: [
        //     {
        //       required: true,
        //       pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        //       message: "请输入正确格式的身份证号"
        //     }
        //   ]
        // }
      ]
    },
    {
      title: {
        label: '安全信息'
      },
      data: [
        {
          name: '密码',
          key: 'password',
          value: '',
          type: -1,
          render(h) {
            return (
              <Button type="primary" onClick={vm.togglePassword}>
                修改密码
              </Button>
            );
          }
        }
      ]
    }
  ];
};
